// extracted by mini-css-extract-plugin
export default {"tags":"styles_tags__SHpV8","tags__actions":"styles_tags__actions__MxGsu","tagsActions":"styles_tags__actions__MxGsu"};